import { UPDATE_SELECTED_QUESTIONS } from '../../sharedActionTypes';
const INITIAL_STATE = {
  selectedQuestions: [],
};

const benchmark = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_SELECTED_QUESTIONS:
      return { ...state, selectedQuestions: action.payload };

    default:
      return state;
  }
};
export default benchmark;
